import React from "react";
import { motion } from "framer-motion";
import {
  ShimmerLoaderwhite,
  ShimmerLoader,
  ShimmerLoaderwhiteOneLine,
  ShimmerOfprofileLoader,
} from "../../utils/loader/ShimmerLoader";
import parser from "html-react-parser";
import styles from "./StandardHeroLayout.module.css";

interface StandardHeroLayoutProps {
  title?: string;
  subtitle?: string;
  description?: string;
  icon: React.ComponentType<any>;
  currentPage?: string;
dp?:boolean;
  backButtonText?: string;
  children?: React.ReactNode;
}

export function StandardHeroLayout({
  title,
  subtitle,
  description,
  icon: IconComponent,
  currentPage,
dp=false,
  backButtonText = "Back",
  children,
}: StandardHeroLayoutProps) {
  return (
    <motion.section
      className={styles.heroSection}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      {/* Top Navigation Bar - Back Button + Floating Navigation */}

      {/* Hero Content */}
      <div className={styles.heroContent}>
        <motion.div
          className={styles.heroIcon}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <IconComponent className={styles.heroIconSvg} />
          <div className={styles.heroIconGlow} />

          {/* Orbiting particles */}
          <div className={styles.orbitingParticles}>
            <div
              className={styles.particle}
              style={{ "--delay": "0s" } as any}
            />
            <div
              className={styles.particle}
              style={{ "--delay": "-1s" } as any}
            />
            <div
              className={styles.particle}
              style={{ "--delay": "-2s" } as any}
            />
            <div
              className={styles.particle}
              style={{ "--delay": "-3s" } as any}
            />
          </div>
        </motion.div>

        {title != "undefined" ? (
          <motion.h1
            className={styles.heroTitle}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            {parser(title as any)}
          </motion.h1>
        ) : (
          <div
            style={{ maxWidth: "600px", width: "100vw", padding: "0px 20px" }}
          >
            {" "}
            <ShimmerLoaderwhiteOneLine />{" "}
          </div>
        )}

        {dp &&
        subtitle != "undefined" &&
        typeof subtitle === "string" &&
        subtitle.trim() !== "" ? (
          <motion.p
            className={styles.heroSubtitle}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            {parser(subtitle)}
          </motion.p>
        ) : ( dp &&
          <div style={{ maxWidth: "600px", width: "100vw", padding: "0 20px" }}>
            <ShimmerLoaderwhiteOneLine />
          </div>
        )}

        { dp && description &&
        description != "undefined" &&
        typeof description === "string" &&
        description.trim() !== "" ? (
          <motion.div
            className={styles.heroDescription}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            <p>{parser(description as any)}</p>
          </motion.div>
        ) : ( dp &&
          <div
            style={{ maxWidth: "600px", width: "100vw", padding: "0px 20px" }}
          >
            {" "}
            <ShimmerLoaderwhite />{" "}
          </div>
        )}

        {children && (
          <motion.div
            className={styles.additionalContent}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1.0 }}
          >
            {children}
          </motion.div>
        )}
      </div>

      {/* Background Effects */}
      <div className={styles.backgroundEffects}>
        <div
          className={styles.gradientOrb}
          style={{ top: "20%", left: "10%" }}
        />
        <div
          className={styles.gradientOrb}
          style={{ top: "60%", right: "15%" }}
        />
        <div
          className={styles.gradientOrb}
          style={{ bottom: "30%", left: "5%" }}
        />
      </div>
    </motion.section>
  );
}
